import React, { useEffect, useState } from 'react';
import KidoProject from '../../../assets/images/new-logo.png';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import useAuthentication from '../../customHooks/authentication';
import useSubscription from '../../customHooks/subscriptionProvider';
import useLangTranslation from '../../customHooks/languageProvider';
import ChooseLanguage from '../../pages/components/modals/ChooseLanguage';
import useFirebase from '../../../useFirebase';
import { setAppLanguageId } from '../../pages/AxiosRtk/Miscellaneous';
import { setDashboardLoader } from '../../pages/AxiosRtk/DashBoard';

const LeftSidebar = () => {
    const { pathname } = useLocation()
    const history = useHistory();
    const dispatch = useDispatch();
    const { handleLogout } = useAuthentication();
    const {
        isSubscriptionAvailable,
        getSubscriptionDetails,
        getTrialDataDetails,
        checkSubsciption
    } = useSubscription();
    const [chooseLangModal, setChooseLangModal] = useState(false);
    const {
        kidList
    } = useSelector(({ dashboard }) => dashboard);
    const { isAdditionalParent } = useSelector(({ auth }) => auth);
    const { appLanguageId } = useSelector(({ misc }) => misc);
    const { getLangTranslation } = useLangTranslation();
    const { getCollectionData } = useFirebase();

    const [selectedItemId, setSelectedItemId] = useState(appLanguageId);

    useEffect(() => {
        getCollectionData("AdminSetRuleData", "Languages");
    }, []);

    function handleChooseLanguage() {
        setChooseLangModal(true);
    }

    function closeModal() {
        setChooseLangModal(false);
    }

    function handleSave() {
        dispatch(setDashboardLoader(true));
        dispatch(setAppLanguageId(selectedItemId));
        closeModal();
        setTimeout(() => {
            dispatch(setDashboardLoader(false));
        }, 3000);
    }

    // Function to initialize and open FreshChat
    function initFreshChat() {
        window.fcWidget.init({
            token: process.env.REACT_APP_FC_WIDGET_TOKEN,
            host: "https://wchat.freshchat.com",
        });
        window.fcWidget.open();
    }

    // Function to load FreshChat script and then call initFreshChat
    function initialize(i, t) {
        var e;
        if (i.getElementById(t)) {
            initFreshChat();
        } else {
            e = i.createElement("script");
            e.id = t;
            e.async = true;
            e.src = "https://wchat.freshchat.com/js/widget.js";
            e.onload = initFreshChat;
            i.head.appendChild(e);
        }
    }

    // Function to trigger FreshChat initialization when Help is clicked
    function initiateCall() {
        initialize(document, "Freshdesk Messaging-js-sdk");
    }

    return (
        <>
            <div className="leftside-menu">
                <Link to="/" className="logo mb-6">
                    <img src={KidoProject} alt="" />
                </Link>
                <div className="h-100 show">
                    {
                        !isAdditionalParent && (
                            <div className='border p-3 rounded mb-6'>
                                <h5 className='text-dark mb-3 text-center text-break'>
                                    {isSubscriptionAvailable() ? getSubscriptionDetails() : getTrialDataDetails()}
                                </h5>
                                <button
                                    className='btn btn-outline-primary w-100'
                                    onClick={() => history.push("/settings")}
                                >{getLangTranslation('PARENT_DASHBOARD_UPGRADE_NOW', 'Upgrade now')}</button>
                            </div>
                        )}

                    <div>
                        <ul className="side-nav d-grid gap-2">
                            <li className={`side-nav-item ${pathname === '/dashboard' ? 'menuitem-active' : ''}`}>
                                <Link to="/dashboard" className="side-nav-link">
                                    <i className='nav-icon icon-grid' />
                                    <span>{getLangTranslation("PARENT_NAV_DASHBOARD", "Dashboard")}</span>
                                </Link>
                            </li>
                            <li className={`side-nav-item ${pathname === '/tasks' ? 'menuitem-active' : ''}`}>
                                <Link to="/tasks" className="side-nav-link">
                                    <i className='nav-icon icon-tasks' />
                                    <span>{getLangTranslation("PARENT_NAV_TASKS", "Tasks")}</span>
                                </Link>
                            </li>
                            <li className={`side-nav-item ${pathname === '/messages' ? 'menuitem-active' : ''}`}>
                                <Link to="/messages" className="side-nav-link">
                                    <i className='nav-icon icon-comment-one' />
                                    <span>{getLangTranslation("PARENT_NAV_MESSAGE", "Messages")}</span>
                                </Link>
                            </li>
                            <li className={`side-nav-item ${pathname === '/settings' ? 'menuitem-active' : ''}`}>
                                <Link to="/settings" className="side-nav-link">
                                    <i className='nav-icon icon-setting' />
                                    <span>{getLangTranslation("PARENT_NAV_SETTING", "Settings")}</span>
                                </Link>
                            </li>

                            <li className={`side-nav-item`} onClick={initiateCall}>
                                <div className='side-nav-link' style={{ cursor: 'pointer' }}>
                                    <i className='nav-icon icon-info' />
                                    <span>{getLangTranslation("PARENT_NAV_HELP", "Help")}</span>
                                </div>
                            </li>

                            <li className={`side-nav-item c-pointer ${chooseLangModal ? 'menuitem-active' : ''}`} onClick={() => handleChooseLanguage()}>
                                <div className='side-nav-link'>
                                    <i className='nav-icon icon-globe' />
                                    <span>{getLangTranslation("PARENT_NAV_CHANGE_LANGUAGE", "Change language")}</span>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className='mt-auto'>
                        {
                            kidList?.length > 0 && !isAdditionalParent && (
                                <button
                                    className="btn btn-primary text-Capitalize text-white w-100 mb-3"
                                    onClick={() => {
                                        if (!checkSubsciption()) {
                                            return;
                                        }
                                        history.push("/add-new-child")
                                    }}
                                >
                                    {getLangTranslation("NEW_FAMILY_ADD_NEW_CHILD", "Add New Child")}
                                </button>
                            )
                        }

                        {
                            !isAdditionalParent && (
                                <button
                                    className="btn btn-outline-primary text-Capitalize mb-3 w-100"
                                    onClick={() => {
                                        history.push("/parent-list")
                                    }}
                                >
                                    {getLangTranslation("NEW_FAMILY_ADD_NEW_PARENT", "Add New Parent")}
                                </button>
                            )
                        }

                        <button
                            className="btn btn-secondary w-100 text-uppercase text-dark d-flex align-items-center gap-3" onClick={handleLogout}
                        >
                            <i className='nav-icon icon-logout fs-5' />
                            {getLangTranslation("PARENT_NAV_LOGOUT", "Logout")}
                        </button>
                    </div>
                </div>

            </div>
            <ChooseLanguage
                showModal={chooseLangModal}
                closeModal={closeModal}
                selectedItemId={selectedItemId}
                setSelectedItemId={setSelectedItemId}
                handleSave={handleSave}
            />
        </>
    )
}

export default LeftSidebar;
